import styled from "@emotion/styled";
import React from "react";
import headerBg from "../../../assets/header-background.png";
import headerImg from "../../../assets/header-image.png";
import { Box, Container, Grid, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import { CustomButton, SectionHeading } from "../../Styles/style";

const HeaderWrapper = styled.div`
  background-image: url(${headerBg});
  background-size: 150px;
  position: relative;

  &::after {
    content: "pepper";
    font-size: 1px;
    color: green;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(0deg, black 10%, transparent);
    height: 12%;
  }
`;
const HeaderImg = styled.img`
  width: 100%;
  height: auto;
  max-width: 600px;
  margin: auto;
`;
const HeaderHeading = styled.span`
  font-family: "RifficFree";
  color: ${(props) => props.theme.hoverSecandary};
  &.green {
    color: ${(props) => props.theme.hoverPrimary};
  }
`;
const Header = () => {
  const theme = useTheme();
  return (
    <HeaderWrapper>
      <Container maxWidth="xl">
        <Grid container alignContent="center" alignItems="center">
          <Grid xs={12} sm={8} lg={6} sx={{ my: 10 }}>
            <SectionHeading
              align="left"
              p="0"
              variant="h1"
              color={theme.textPrimary}
            >
              <HeaderHeading>PEP</HeaderHeading>
              <HeaderHeading className="green">PER</HeaderHeading>
            </SectionHeading>
            <Typography
              variant="subtitle1"
              color={theme.textPrimary}
              sx={{ maxWidth: 450, py: 3 }}
            >
              Hey, I'm Pepper and I want to surprise Pepe with my own crypto
              token. I've been trying my best to take an interest in Pepe's
              hobbies and I think nothing can beat a bit of friendly
              spousal rivalry!
            </Typography>
            <Box sx={{ display: "flex" }}>
              <CustomButton href="https://app.uniswap.org/#/swap?outputCurrency=0x24ABCa46E6bF3e18b870F9F5Cc1A361ECE13C68d" className="primary">Buy Now</CustomButton>
              <CustomButton href="https://www.dextools.io/app/en/ether/pair-explorer/0x24ABCa46E6bF3e18b870F9F5Cc1A361ECE13C68d">
                View Chart
              </CustomButton>
            </Box>
          </Grid>
          <Grid xs={12} sm={4} lg={6} sx={{ textAlign: "center" }}>
            <HeaderImg src={headerImg} alt="Header-pepper-image" />
          </Grid>
        </Grid>
      </Container>
    </HeaderWrapper>
  );
};

export default Header;
